import * as Constants from "../../../../Constants";
import * as RawKpiConstants from "../../../../gateway/service/modules/kpi/enums/RawKpiConstants";
const DATA_SEPARATOR = ';';
const LINE_SEPARATOR = ';\n';
const EMPTY = '';

const HEADER = "IFS;TIME_ELAPSED_MS;THROUGHPUT_KBPS;GPS_LAT;GPS_LONG;GPS_RADIUS;VERSION;NETSTAT;DATASTATE;MCC;MNC;CID;LAC;BEARER;PSC;RSSI;RSSI_RAW;CQI;RSRP;RSRP_RAW;RSRQ;RSRQ_RAW;SNR;SNR_RAW;IP;IMSI;WIFI_STATE;WIFI_SSID;WIFI_BSSID;WIFI_FREQ;WIFI_SPEED;WIFI_RSSI;IMEI;GPS_LAT;GPS_LONG;GPS_RADIUS;GPS_TIMESTAMP;DATE_ISO;RESERVED;";
/**
 * Parse the raw data generate by Web Agent to mScore format
 */
export default class RawDataParser {

    /**
     * Empty constructor
     */
    constructor() {
    }

    /**
     * Format raw data to mScore data
     *
     * @param {Array.<EQmScoreStepProgress>} rawData collected by agent
     * @return {string} data to post to mScore
     */
    formatLogs(rawData = null) {
        if (!rawData) {
            return '';
        }
        let lines = [];
        rawData.forEach((data) => {
            lines.push(this.formatLine(data));
        });
        return HEADER + '\n' + lines.join(LINE_SEPARATOR) + 'ENDOFPOST;';
    }

    getGatewayInfos(log, key) {
        if (log.routerInfos && log.routerInfos[key]) {
            if (typeof log.routerInfos[key].code != "undefined") {
                return log.routerInfos[key].code;
            } else {
                return log.routerInfos[key];
            }
        } else {
            return EMPTY;
        }
    }

    /**
     *
     * @param {EQmScoreStepProgress} log
     */
    formatLine(log) {
        let data = [];

        data.push("IFS");
        data.push(log.sessionTime);
        data.push(log.instantThroughput());
        data.push(log.gpsInfos.lat);
        data.push(log.gpsInfos.long);
        data.push(log.gpsInfos.radius);

        data.push(Constants.AGENT_VERSION);
        // data.push("2.1");

        // Radio netstat
        data.push(this.getGatewayInfos(log, RawKpiConstants.NETSTAT));
        // Radio datastate
        data.push(EMPTY);
        // Radio mcc
        data.push(this.getGatewayInfos(log, RawKpiConstants.MCC));
        // Radio mnc
        data.push(this.getGatewayInfos(log, RawKpiConstants.MNC));

        // Radio cid
        data.push(this.getGatewayInfos(log, RawKpiConstants.CELL_ID));
        // Radio lac
        data.push(EMPTY);
        // Radio bearer
        data.push(this.getGatewayInfos(log, RawKpiConstants.BEARER));
        // Radio PSC/PCI
        if (this.getGatewayInfos(log, RawKpiConstants.PSC) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.PSC));
        } else if (this.getGatewayInfos(log, RawKpiConstants.PCI) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.PCI));
        } else {
            data.push(EMPTY);
        }
        // Radio RSSI
        data.push(this.getGatewayInfos(log, RawKpiConstants.RSSI));
        data.push(EMPTY);
        // Radio CQI
        data.push(EMPTY);
        // Radio RSRP/RSCP
        if (this.getGatewayInfos(log, RawKpiConstants.RSRP) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.RSRP));
        } else if (this.getGatewayInfos(log, RawKpiConstants.RSCP) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.RSCP));
        } else {
            data.push(EMPTY);
        }
        data.push(EMPTY);
        // Radio RSRQ/ECNO
        if (this.getGatewayInfos(log, RawKpiConstants.RSRQ) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.RSRQ));
        } else if (this.getGatewayInfos(log, RawKpiConstants.ECNO) != EMPTY) {
            data.push(this.getGatewayInfos(log, RawKpiConstants.ECNO));
        } else {
            data.push(EMPTY);
        }
        data.push(EMPTY);
        // Radio SNR
        data.push(this.getGatewayInfos(log, RawKpiConstants.SNR) == EMPTY ? 0 : this.getGatewayInfos(log, RawKpiConstants.SNR));
        data.push(EMPTY);
        // LOCAL IP
        data.push(this.getGatewayInfos(log, RawKpiConstants.LOCAL_IP));
        // SIM IMSI
        data.push(this.getGatewayInfos(log, RawKpiConstants.IMSI));
        // WIFI state
        data.push(EMPTY);
        // WIFI ssid
        data.push(EMPTY);
        // WIFI bssid
        data.push(EMPTY);
        // WIFI freq
        data.push(EMPTY);
        // WIFI speed
        data.push(EMPTY);
        // WIFI RSSI
        data.push(EMPTY);
        // IMEI
        data.push(this.getGatewayInfos(log, RawKpiConstants.IMEI));
        data.push(log.gpsInfos.lat);
        data.push(log.gpsInfos.long);
        data.push(log.gpsInfos.radius);
        data.push(log.gpsInfos.timestamp);
        // Date in ISO format of the raw data
        data.push(new Date(log.timestamp).toISOString());

        // Add a separator at the end of the line
        return data.join(DATA_SEPARATOR) + DATA_SEPARATOR;
    }


}


// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/result/RawDataParser.js